import { axiosHelper } from 'Services/AxiosHelper';
import { OnUpdateCommercialStatusModel } from 'Models';
import { onUpdateCommercialStatusReqBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnUpdateCommercialStatus';

const onUpdateCommercialStatus = async (
  params: onUpdateCommercialStatusReqBodyData
): Promise<OnUpdateCommercialStatusModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onUpdateCommercialStatus;
